import React from 'react';
import PropTypes from 'prop-types';
import KpiTable from '../../../commons/KpiTable';
import { isNaN, isNil } from 'lodash';

const ContentMasteryTestFailureAttemptRateTable = (props) => (
  <KpiTable
    title="Failures over attempts"
    description="The percentage represents the number of failed attempts out of all attempts. The exercises which represent this number are: Single Choice Text, Single Choice Audio, Single Choice Image, Dictation, Gap Fill, Gap Fill Select, Gap Fill Multiple, True or False, Unscramble Drag and Drop and Unscramble Speech Recognition."
    loading={props.loading}
    values={props.values}
    currentHigherIsBetter={false}
    onSelect={props.onSelect}
    formatter={props.formatter}
    nameColumnPath={props.nameColumnPath}
    nameColumnRender={props.nameColumnRender}
    additionalColumns={[
      {
        label: 'Attempts',
        path: 'totalAttempts',
        sort: true,
        render: (value) => {
          if (isNil(value) || isNaN(value)) {
            return 'N/A';
          }
          return value;
        },
      },
    ]}
    feedbackColorRender={props.feedbackColorRender}
  />
);

ContentMasteryTestFailureAttemptRateTable.propTypes = {
  onSelect: PropTypes.func.isRequired,
  nameColumnRender: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  values: PropTypes.array.isRequired,
  formatter: PropTypes.func.isRequired,
  feedbackColorRender: PropTypes.func.isRequired,
};

ContentMasteryTestFailureAttemptRateTable.defaultProps = {
  nameColumnPath: 'order',
};

export default ContentMasteryTestFailureAttemptRateTable;
